module.exports = __webpack_public_path__ + "Linearicons-Free.2f3e9f80fff7d699dd3d";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.ttf?w118d
// module id = ../../../../../src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.ttf?w118d
// module chunks = styles